import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import ruTranslation from './locales/ru/translation.json';
import etTranslation from './locales/et/translation.json';
import lvTranslation from './locales/lv/translation.json';

const supportedLanguages = ['et', 'en', 'ru', 'lv'];

const getInitialLanguage = () => {
  if (typeof navigator === 'undefined') return 'en';

  const browserLanguage = navigator.language || navigator.userLanguage || '';
  const languageCode = browserLanguage.toLowerCase().split('-')[0];

  return supportedLanguages.includes(languageCode) ? languageCode : 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    ru: { translation: ruTranslation },
    et: { translation: etTranslation },
    lv: { translation: lvTranslation },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false, // Не экранировать HTML
  },
});

export default i18n;
